export const ORDERS_PAYMENT_TYPE = {
  invoiced: 7,
};

export const SUL_AMERICA_STATUS = {
  cancelled: 1,
  result_available: 2,
  collected: 3,
  rescheduled: 4,
};
